import axios from "axios";
import { debounce } from "lodash";
import React from "react";
import * as Survey from "survey-react";
import { API_ENDPOINTS } from "../../util/constants";

Survey.StylesManager.applyTheme("modern");
export class FeedbackComponent extends React.Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate() {
    return false;
  }
  render() {
    return <_FeedbackComponent {...this.props} />;
  }
}
//export
const _FeedbackComponent = (props) => {
  Survey.modernCss.question.titleOnAnswer = "";
  Survey.modernCss.question.titleOnError = "";

  const jsonData = {
    firstPageIsStarted: true,
    completeText: "Finish",
    completedHtml: "Thanks for your feedback!",
    completedBeforeHtml: "",
    startSurveyText: "Give Feedback",
    pages: props.questionList,
  };

  const survey = new Survey.Model(jsonData);

  survey.onComplete.add(function(sender) {
    const url = API_ENDPOINTS.feedbackSubmission;
    let surveyData = sender.data;
    axios.post(url, { surveyData });
    debounce(props.closeFeedbackFormModal, 500)();
  });
  return <Survey.Survey model={survey} />;
};
